<template>
	<div class="filters">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-lg-11">
					<div class="filters__divider"></div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-4">
					<div class="flex">
						<h3 class="filters__headline">{{$t('filters.comments')}}</h3>
					</div>
				</div>
				<div class="col-sm-12 col-lg-2">
					<div class="filter__wrapper">
						<input type="text"
							   :placeholder="$t('filters.dog')"
							   class="filter filter--gray"
							   :class="{open: 'open' === showList, close: 'open' !== showList}"
							   @click="updateShowList('open')"
							   v-model="searchByBreed"
						>
						<ul v-show="'open' === showList"
							class="filter__list"
						>

							<li v-for="item in breedsList"
								class="filter__list-item"
							>
								<label class="filter__label">{{item.name}}
									<input class="filter__input"
										   type="checkbox"
										   :value="item"
										   @change="addBreeds($event, item)"
									>
									<span class="filter__checkbox"></span>
								</label>
							</li>
						</ul>
					</div>
				</div>

				<div class="col-sm-12 col-lg-2">
					<div class="filter__wrapper">
						<input type="text"
							   :placeholder="$t('filters.group')"
							   class="filter filter--gray"
							   :class="{open: 'group' === showList, close: 'group' !== showList}"
							   @click="updateShowList('group')"
							   v-model="searchByGroup"
						>
						<ul v-show="'group' === showList"
							class="filter__list"
						>

							<li v-for="item in groupsList"
								class="filter__list-item"
							>
								<label class="filter__label">{{item.name}}
									<input class="filter__input"
										   type="checkbox"
										   :value="item"
										   @change="addGroups($event, item)"
									>
									<span class="filter__checkbox"></span>
								</label>
							</li>
						</ul>
					</div>
				</div>

				<div class="col-sm-12 col-lg-2">
					<div class="filter__wrapper">
						<input class="filter filter--gray comment__input comment__input--breed"
							   :class="{open: 'stars' === showList, close: 'stars' !== showList}"
							   @click="updateShowList('stars')"
							   :placeholder="$t('filters.stars.name')"
							   v-model="searchByStars"
						>
						<ul v-show="'stars' === showList"
							class="filter__list"
						>
							<li class="filter__list-item" @click="removeStar()">{{$t('filters.remove')}}</li>
							<li class="filter__list-item"
								v-for="star in 6"
								@click="selectStars(star)"
								:class="{'filter__list-item--active': searchByStars == star}"
							>
								{{star}}
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-11">
					<div class="filters__divider"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		data () {
			return {
				showList: '',
				breeds: [],
				searchByBreed: '',
				groups: [],
				searchByGroup: '',
				searchByStars: '',
				activeBreeds: [],
				activeGroups: [],
				activeStar: '',
				filters: {
					activeBreeds: [],
					activeGroups: [],
					activeStar: ''
				}
			}
		},
		methods: {
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					this.showList = list
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *') && !e.target.matches('.close, .close *') && !e.target.matches('.open, .open *')) {
					this.showList = ''
				}
			},
			removeFilter (e) {
				this.selectedFilters = this.selectedFilters.filter(filter => {
					return filter !== e.target.getAttribute('data-tag')
				})
			},
			fetchBreeds () {
				axios.get('/api/dogs/subgroup/autocomplete/', {
				})
					.then(response => {
						this.breeds = response.data
					})
					.catch(error => {
						console.error(error)
					})
			},
			addBreeds (e, item) {
				if (e.target.checked) {
					this.filters.activeBreeds.push(item.id)
					this.$emit('filterComments', this.filters)
				} else {
					this.filters.activeBreeds = this.filters.activeBreeds.filter(breed => breed !== item.id)
					this.$emit('filterComments', this.filters)
				}
			},
			fetchGroups () {
				axios.get('/api/dogs/group/autocomplete/', {
				})
					.then(response => {
						this.groups = response.data
					})
					.catch(error => {
						console.error(error)
					})
			},
			addGroups (e, item) {
				if (e.target.checked) {
					this.filters.activeGroups.push(item.id)
					this.$emit('filterComments', this.filters)
				} else {
					this.filters.activeGroups = this.filters.activeGroups.filter(breed => breed !== item.id)
					this.$emit('filterComments', this.filters)
				}
			},
			selectStars (star) {
				this.searchByStars = star
				this.filters.activeStar = star
				this.showList = ''
				this.$emit('filterComments', this.filters)
			},
			removeStar () {
				this.searchByStars = ''
				this.filters.activeStar = ''
				this.$emit('filterComments', this.filters)
			}
		},
		computed: {
			breedsList () {
				const inputTest = breed => {
					const regExp = new RegExp('^' + this.searchByBreed, 'i')
					return regExp.test(breed.name)
				}
				return this.breeds.filter(inputTest)
			},
			groupsList () {
				const inputTest = group => {
					const regExp = new RegExp('^' + this.searchByGroup, 'i')
					return regExp.test(group.name)
				}
				return this.groups.filter(inputTest)
			}
		},
		created () {
			this.fetchBreeds()
			this.fetchGroups()
			window.addEventListener('click', this.closeFlitersLists)
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";
	@import "../../../styles/filters.scss";

	.filters {
		padding-top: 15px;
		background-color: #fff;

		&__divider {
			width: 100%;
			height: 4px;
			background-color: $black;
			margin-bottom: 20px;
		}

		&__headline {
			font-family: $lato-bold;
			font-size: 16px;
			letter-spacing: 0.05em;
			text-transform: uppercase;
			text-align: left;
			margin: 0;
		}
	}
	.flex {
		display: flex;
		align-items: center;
		height: 40px;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Judge/Details/FiltersComponents.vue